const SolicitacaoParticipacaoCirurgiaOptions = [
  { id: 14, text: "Médico principal", value: "MedicoPrincipal" },
  { id: 15, text: "Médico Auxiliar", value: "MedicoAuxiliar" },
  { id: 16, text: "Instrumentador", value: "Instrumentador" },
  { id: 17, text: "Observador", value: "Observador" },
  { id: 18, text: "Multiprofissional", value: "Multiprofissional" }
];

export { SolicitacaoParticipacaoCirurgiaOptions };
